import { useState } from "react";
import { RiKakaoTalkFill } from "react-icons/ri";
import Button from "../components/common/Button";
import { useNavigate } from "react-router-dom";
import { ROUTE_PATH, STORAGE_KEY } from "../constants";
import { useTranslation } from "react-i18next";

const KakaoAuthPage = () => {
  const [isChecked, setIsChecked] = useState(false);

  const navigate = useNavigate();
  const { t } = useTranslation();

  const skipKakao = localStorage.getItem(STORAGE_KEY.SKIP_KAKAO) === "true";

  const handleNavigation = () => {
    const config = localStorage.getItem(STORAGE_KEY.CONFIG);

    if (config) {
      const { roomSelectYn } = JSON.parse(config);
      navigate(roomSelectYn ? ROUTE_PATH.ROOM : ROUTE_PATH.PAYMENT);
    }
  };

  const handleKakaoLogin = () => {
    const { Kakao } = window as any;

    if (!Kakao.isInitialized()) {
      Kakao.init(process.env.REACT_APP_KAKAO_JAVASCRIPT_KEY);
    }

    Kakao.Auth.login({
      success: () => {
        handleNavigation();
      },
      fail: (error: unknown) => {
        console.error(error);
      }
    });
  };

  const handleConfirm = () => {
    localStorage.removeItem(STORAGE_KEY.SKIP_KAKAO);
    handleNavigation();
  };

  return (
    <div className="flex flex-col gap-y-6">
      <h1 className="text-xl font-bold">{t("self_authentication")}</h1>
      {!skipKakao && <span className="text-gray-800 text-sm">{t("verify_kakao")}</span>}
      <div className="flex items-start gap-x-2">
        <input
          id="adult_confirm"
          type="checkbox"
          checked={isChecked}
          onChange={() => setIsChecked((prev) => !prev)}
          className="w-4 h-4"
        />
        <label htmlFor="adult_confirm" className="text-sm">
          {t("adult_confirm")}
          <br />
          {t("birthdate_verified")}
        </label>
      </div>
      {skipKakao ? (
        <Button onClick={handleConfirm} disabled={!isChecked}>
          {t("confirm")}
        </Button>
      ) : (
        <Button
          variant={isChecked ? "none" : "contained"}
          className="relative bg-[#FEE500]"
          onClick={handleKakaoLogin}
          disabled={!isChecked}
        >
          <RiKakaoTalkFill size={26} className="absolute left-5" />
          {t("kakao_login")}
        </Button>
      )}
    </div>
  );
};

export default KakaoAuthPage;
